function handlePermission(permissions_list, permission) {
  if (!permission) return false;

  const arr = permissions_list || [];

  return arr.some((p) => p?.codename === permission);
}

export default handlePermission;
